import React from 'react'

import { arrayOf, shape, string } from 'prop-types'

import FormSubmit from 'Pods/DiscoverLandings/Shared/FormSubmit/FormSubmit'
import useLeadForm from 'Pods/DiscoverLandings/Shared/Hooks/useLeadForm'
import InputField from 'Pods/DiscoverLandings/Shared/InputField/InputField'
import SelectField from 'Pods/DiscoverLandings/Shared/SelectField/SelectField'

import LegalNote from './Components/LegalNote/LegalNote'

export const CAPTCHA_ID = 'datasets-lead-captcha'

const fieldShape = shape({ label: string.isRequired, placeholder: string.isRequired })

function LeadForm({ form }) {
  const {
    handleFocus, handleSubmit, isCaptchaRequested, isSubmitting, error,
  } = useLeadForm({ form: 'datasets', captchaId: CAPTCHA_ID })

  return (
    <div className="datasets-lead-form">
      <form className="datasets-lead-form__fields" onFocus={handleFocus} onSubmit={handleSubmit}>
        <InputField
          id="datasets-email"
          name="email"
          type="email"
          autoComplete="email"
          label={form.email.label}
          placeholder={form.email.placeholder}
          required
          isDark
        />
        <SelectField
          id="datasets-dataset-type"
          name="dataset_type"
          label={form.datasetType.label}
          placeholder={form.datasetType.placeholder}
          options={form.datasetType.options}
          required
          isDark
        />
        <InputField
          id="datasets-company"
          name="company"
          autoComplete="organization"
          label={form.company.label}
          placeholder={form.company.placeholder}
          isDark
        />
        <FormSubmit
          captchaId={CAPTCHA_ID}
          label={form.submit}
          errors={form.errors}
          isCaptchaRequested={isCaptchaRequested}
          isSubmitting={isSubmitting}
          error={error}
          className="datasets-lead-form__submit"
        />
      </form>
      <LegalNote legal={form.legal} />
    </div>
  )
}

LeadForm.propTypes = {
  form: shape({
    email: fieldShape.isRequired,
    datasetType: shape({
      label: string.isRequired,
      placeholder: string.isRequired,
      options: arrayOf(shape({ value: string.isRequired, label: string.isRequired })).isRequired,
    }).isRequired,
    company: fieldShape.isRequired,
    submit: string.isRequired,
    legal: shape({ text: string.isRequired }).isRequired,
    errors: shape({ captcha: string.isRequired, generic: string.isRequired }).isRequired,
  }).isRequired,
}

export default LeadForm
